/**
 * @ngdoc directive
 * @name qpAccept
 * @restrict A
 * 
 * @description
 * 對ng-model進行監控，限制其輸入類型
 * 
 *  @param {string} acceptType 
 *  包含以下類型
 *  number:數字類型，可以配置以下屬性
 *      allowNegative:允許負數，true/false
 *      allowDecimal：允許小數，true/false
 *      decimalPrecision:小數精確度（小數后保留多少位），number
 */
angular.module("qp.core.commons.utils", [])
    .directive("qpAccept", function () {

        /**
         * @ngdoc function
         * @name saveProductInstanceCallback
         * 數字類型處理
         */
        var numberInputRegular = function (scope, element, attrs, e) {
            var keyCode = e.keyCode || e.which;
            var checkValue = false;

            //通用按鈕，回退、Tab等，請參照https://css-tricks.com/snippets/javascript/javascript-keycodes/
            if ([8, 9, 13, 16, 17, 18, 20, 27, 37, 39, 46, 136].indexOf(keyCode) != -1) {
                checkValue = true;
            }

            //負數處理
            if (!checkValue && attrs.allowNegative != "false") {
                if (keyCode == 45) {
                    checkValue = true;
                }
            }

            //小數處理
            if (!checkValue && attrs.allowDecimal != "false") {
                if (keyCode == 46) {
                    checkValue = true;
                }
            }

            //數字按鈕
            if (!checkValue) {
                if (keyCode >= 48 && keyCode <= 57) {
                    checkValue = true;
                }
            }

            //處理結果，沒有通過的，拒絕輸入
            if (checkValue) {
                scope.$apply(function (arg) {
                    scope.$eval(attrs.qpAccept);
                });
            }
            else {
                e.preventDefault();
            }
        };

        /**
         * 檢查文本
         * @param {type} attrs
         * @param {type} text
         * @returns
         */
        var validateNumberValue = function (attrs, text) {
            var regRule = "^";

            //負數校驗
            if (attrs.allowNegative != "false") {
                regRule += "(-)?";
            }

            //整數部份
            regRule += "(\\d)+";

            //小數部份
            if (attrs.allowDecimal != "false") {
                var n = attrs.decimalPrecision;
                if (n) {
                    regRule += "(.\\d{1," + n + "})*";
                }
                else {
                    regRule += "(.\\d)*";
                }
            }

            //結束
            regRule += "$";

            var reg = new RegExp(regRule);
            return reg.test(text);
        };

        /**
         * 類型
         */
        var acceptTypes = {
            /**
             * 數字類型，輸入事件
             */
            number: numberInputRegular,
            /**
            * Value驗證方法
            */
            numberValidate: validateNumberValue

        };

        //返回處理函數
        return {
            restrict: "A",
            link: function (scope, element, attrs) {

                if (["number"].indexOf(attrs.qpAccept) == -1)
                    throw new Error("invalid accept type " + attrs.qpAccept);

                //控制按鍵事件
                element.bind("keypress", function (e) {
                    acceptTypes[attrs.qpAccept](scope, element, attrs, e);
                });
                //控件剪切板事件
                element.bind("paste", function (e) {
                    //獲取剪切板內容
                    var clipboard = e.clipboardData || e.originalEvent.clipboardData || window.clipboardData;
                    return acceptTypes[attrs.qpAccept + "Validate"](attrs, clipboard.getData("Text"));
                });
            }
        };
    });